import { Helmet } from 'react-helmet-async';

const SITE = 'https://ryanmarfone.com';
const DEFAULT_OG = `${SITE}/og.png`;

// Public case slugs that have a generated /case-studies/<slug>/og.png.
const CASES_WITH_OG = new Set(['coptic', 'iris', 'sleep', 'uikit', 'workshops']);

function abs(url) {
  if (!url) return DEFAULT_OG;
  if (/^https?:\/\//i.test(url)) return url;
  return SITE + (url.startsWith('/') ? url : '/' + url);
}

function ogImageFor(path, image) {
  // Prefer the per-case og.png if one exists for this route.
  const m = (path || '').match(/^\/case\/([^/?#]+)$/);
  if (m && CASES_WITH_OG.has(m[1])) {
    return `${SITE}/case-studies/${m[1]}/og.png`;
  }
  return abs(image);
}

export default function Seo({
  title,
  description,
  image,
  path = '/',
  gated = false,
  type = 'website',
  jsonLd,
}) {
  const fullTitle = title ? `${title} · Ryan Marfone` : 'Ryan Marfone · Fractional Chief Product Designer';
  const desc = description || 'Fractional Chief Product Designer. Twenty years shaping retail, commerce, healthcare, and AI experiences.';
  const ogImage = ogImageFor(path, image);
  const canonical = SITE + (path.startsWith('/') ? path : '/' + path);
  const robots = gated ? 'noindex, nofollow' : 'index, follow';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {!gated && jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
